export enum FlowsheetType {
  HYDROCARBON = 'hydrocarbon',
  UTILITIES = 'utilities',
}
